<div echarts [options]="options" class="matrix-chart"></div>